import { RepositoryException } from "../../../domain/exceptions/exceptions";

export async function wrapErrorHandler<T>(
  callback: () => Promise<T>
): Promise<T> {
  try {
    return await callback();
  } catch (e) {
    const errorResponse = e.response;
    const webServiceError = e?.response?.data;

    if (e?.response?.status === 403) {
      throw new RepositoryException(
        "Faça seu login novamente.",
        "ACCESS_SESSION_EXPIRED"
      );
    }

    if (e?.response?.status === 401) {
      throw new RepositoryException(
        webServiceError.message,
        "WRONG_CREDENTIALS"
      );
    }

    if (!errorResponse) {
      throw new RepositoryException("Erro de conexão.", "UNEXPECTED_ERROR");
    }

    if (!webServiceError || !webServiceError.code || !webServiceError.message) {
      console.error(e);
      throw new RepositoryException(
        "Ocorreu um erro inesperado.",
        "UNEXPECTED_ERROR"
      );
    }

    if (webServiceError.code === "UNEXPECTED_ERROR") {
      console.error(webServiceError.message);
      throw new RepositoryException(
        "Ocorreu um erro inesperado.",
        "UNEXPECTED_ERROR"
      );
    }

    throw new RepositoryException(
      webServiceError.message,
      webServiceError.code
    );
  }
}
